import { getServerApi } from '../../../config/deployment'
import { performRequest_GET, performRequest_PUT } from '../../utils/http/httpService'
import store from '../../../vuex/store'

let envUri = getServerApi()
let privatePersonUri = envUri + '/api/persons/private'
let juridicalPersonUri = envUri + '/api/persons/juridical'


export const getJuridicalPerson = (personQuery) => {
  if (personQuery.id) return getJuridicalPersonById(personQuery.id)
  else if (personQuery.byRegNr) return getJuridicalPersonByRegNr(personQuery.regNr, personQuery.regCountry)
  else if (personQuery.byName) return getJuridicalPersonByName(personQuery.name, personQuery.regCountry)
  return Promise.reject("Invalid query");
}

export const getJuridicalPersonByRegNr = (regNr, regCountry) => {
  if (regNr && regCountry) return getJuridicalPersonActual({ regNr: regNr, regCountry: regCountry })
  else return Promise.reject("missing search params")
}
export const getJuridicalPersonByName = (name, regCountry) => {
  if (name && regCountry) return getJuridicalPersonActual({ name: name, regCountry: regCountry })
  else return Promise.reject("missing search params")
}

export const getPrivatePerson = (personQuery) => {
  if (personQuery.id) return getPrivatePersonById(personQuery.id)
  if (personQuery.byIdCode) return getPrivatePersonByIdCode(personQuery.idCode)
  else if (personQuery.bySsnTax) return getPrivatePersonBySsnTax(personQuery.ssnTaxNr, personQuery.givenName, personQuery.surname, personQuery.dob)
  return Promise.reject("Invalid query");
}

export const getJuridicalPersonById = (id) => {
  if(!id) return  Promise.reject("missing search params")
  var persons = store.getters.jurPersons
  if(persons){
    for(var i = 0; i < persons.length; i++){
      if((!persons[i].state || persons[i].state != "loading") && persons[i]._id == id) {
        return Promise.resolve(persons[i])
      }
    }
  }
  return getPerson(juridicalPersonUri + "/" + id, {})
}

export const getPrivatePersonById = (id) => {
  if(!id) return  Promise.reject("missing search params")
  var person = store.getters.privatePerson
  if((!person.state || person.state != "loading") && person._id == id){
    return Promise.resolve(person)
  } 
  return getPerson(privatePersonUri + "/" + id, {})
}

export const getPrivatePersonByIdCode = (idCode) => {
  if (idCode) return getPrivatePersonActual({ idCode: idCode })
  else return Promise.reject("missing search params")
}
export const getPrivatePersonBySsnTax = (ssnTaxNr, givenName, surname, dob) => {
  if (ssnTaxNr && givenName && surname && dob) return getPrivatePersonActual({ ssnTaxNr: ssnTaxNr, givenName: givenName, surname: surname, dob: dob })
  else return Promise.reject("missing search params")
}

export const upsertPrivatePerson = ({person, accountId}) => {
  return new Promise((resolve, reject) => {
    if (person) {
      var data = {
        person: person,
        connectToAccount: accountId
      }
      performRequest_PUT(privatePersonUri, data)
        .then(resp => {
          if (resp.success) {
            resolve(resp.response.data.body)
          }
          else reject(resp.error)
        })
        .catch(err => {
          reject(err)
        })
    } else {
      reject("missing search params")
    }
  })
}

export const upsertJurPerson = ({person, privPersonId, connectionType, accountId}) => {
  return new Promise((resolve, reject) => {
    if (person) {
      var data = {
        person: person,
        connectToPrivPersonId: privPersonId,
        connectionType: connectionType,
        connectToAccount: accountId
      }
      performRequest_PUT(juridicalPersonUri, data)
        .then(resp => {
          if (resp.success) {
            resolve(resp.response.data.body)
          }
          else reject(resp.error)
        })
        .catch(err => {
          reject(err)
        })
    } else {
      reject("missing search params")
    }
  })
}

function getJuridicalPersonActual(params) {
  return getPerson(juridicalPersonUri, params)
}
function getPrivatePersonActual(params) {
  return getPerson(privatePersonUri, params)
}

function getPerson(url, params) {
  return new Promise((resolve, reject) => {
    performRequest_GET(url, params)
      .then(resp => {
        if (resp.success) resolve(resp.response.data.body)
        else reject(resp.error)
      })
      .catch(err => {
        reject(err)
      })
  })
}



// WEBPACK FOOTER //
// ./src/platform/person/repository/personRepository.js